<template>
  <div class="_backoffice_empatik">

    <div class="d-flex justify-space-between">
      <div :style="`margin-bottom:20px; font-size:25px; font-weight:700; color:${scdColor}`">
        Elenco Notifiche
      </div>
      <!-- <v-btn @click="apriDialogNuovaNotifica()" depressed :color="scdColor" style="color:white; text-transform:none;">
        Nuova notifica
      </v-btn> -->
      <v-btn @click="nuovaNotificaRoute('nuova')" depressed :color="scdColor" style="color:white; text-transform:none;">
        Nuova notifica
      </v-btn>
    </div>
    <div>
      <v-data-table
        :headers="headersNotifiche"
        :items="notifiche"
        style="width:100%;"
        :loading="caricamentoTabellaNotifiche"
				:footer-props="{
					'items-per-page-text': 'Notifiche per pagina',
					'items-per-page-all-text': 'Tutte',
					'items-per-page-options':[5, 15, 30, -1],
					'options': {
						 itemsPerPage: 15,
					}
				}"
				
      >
        <template v-slot:header.totale>
          <v-icon style="font-size:18px;">mdi-bell</v-icon>
        </template>
        <template v-slot:header.visualizzate>
          <v-icon style="font-size:18px;">mdi-eye</v-icon>
        </template>
        <template v-slot:header.lette>
          <v-icon style="font-size:18px;">mdi-check</v-icon>
        </template>
        <template v-slot:item.titolo="{ item }">
          <span style="color:black;">{{ item.titolo }}</span>
        </template>
        <template v-slot:item.stato="{ item }">
          <span :style="`color:${getColoreStato(item.stato)}`">{{ item.stato }}</span>
        </template>
        <template v-slot:item.azioni="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <!-- <v-icon v-on="on" @click="apriDialogModificaNotifica(item)" style="font-size:18px;">mdi-pencil</v-icon> -->
              <v-icon v-on="on" @click="modificaNotificaRoute(item)" style="font-size:18px;">mdi-pencil</v-icon>
            </template>
            <span>Modifica</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" @click="apriDialogEliminaNotifica(item.id)" style="font-size:18px;">mdi-delete</v-icon>
            </template>
            <span>Elimina</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>

    <!-- <v-dialog persistent v-model="dialogNotificaAperta" max-width="1223px">
      <v-card class="_backoffice_empatik">
        <v-card-title>
          <div :style="`font-size:25px; font-weight:700; color:${scdColor}`">
            <span v-if="nuovaOppureModifica == 'nuova'">Nuova Notifica</span>
            <span v-if="nuovaOppureModifica == 'modifica'">Modifica Notifica</span>
          </div>
          <v-spacer></v-spacer>
          <v-btn color="black--text" icon @click="dialogNotificaAperta = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <nuova-oppure-modifica-notifica-component v-if="dialogNotificaAperta" 
            :azione="nuovaOppureModifica" 
            :notifica="datiNotificaDaModificare" 
            @chiudi-dialog="dialogNotificaAperta = false" 
            @aggiorna-tabella-notifiche="getNotifichePerBackoffice()"
          ></nuova-oppure-modifica-notifica-component>
        </v-card-text>
      </v-card>
    </v-dialog> -->

    <v-dialog persistent v-model="dialogEliminaNotificaAperta" max-width="550">
      <v-card>
        <v-card-title>
        </v-card-title>
        <v-card-text>
          <p v-if="!mostraAvvisoNotificaEliminata && !eliminazioneNotificaInCorso" :style="`font-size: 18px; font-weight:500; color:${scdColor}`">
            <span>Vuoi eliminare la notifica?</span>
          </p>
          <v-form ref="eliminaNotificaForm">
            <v-text-field
              v-if="!mostraAvvisoNotificaEliminata && !eliminazioneNotificaInCorso"
              label="Inserisci la parola: EMPATIK"
              outlined
              v-model="parolaChiave"
              :rules="[vincoli.required, regole.empatik]"
              ></v-text-field>
            </v-form>
          <p v-if="eliminazioneNotificaInCorso" :style="`font-size: 18px; font-weight:500; color:${scdOrange}`">
            <span>Eliminazione in corso...</span>
          </p>
          <v-progress-linear
            v-if="eliminazioneNotificaInCorso"
            :color="scdOrange"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
          <p v-if="mostraAvvisoNotificaEliminata" :style="`font-size: 18px; font-weight:500; color:${scdColor}`">
            <span>Notifica eliminata!</span>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="mostraBottoniPreEliminazione"  class="mb-1 px-4" style="text-transform:none;" dark rounded depressed :color="scdColor" @click="dialogEliminaNotificaAperta = false">Annulla</v-btn>
          <v-btn v-if="mostraBottoniPreEliminazione" class="mb-1 px-4" style="text-transform:none;" dark rounded depressed :color="`${scdRed}`" @click="eliminaNotifica()">Elimina</v-btn>
          <v-btn v-if="mostraBottonePostEliminazione" class="mb-1 px-4" style="text-transform:none;" dark rounded depressed :color="scdColor" @click="resetDialogEliminaNotifica()">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import mixin from '../../../mixins';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  data() {
    return {
      regole: {
        empatik: v => v == 'EMPATIK' || "La parola inserita non è valida",
      },
      notifiche: [],
      headersNotifiche: [
        { text: "Titolo", value: "titolo", searchable: true, sortable: true },
        { text: "Tipo", value: "nomeFrontend", searchable: true, sortable: true },
        { text: "Destinatari", value: "destinatari", searchable: true, sortable: true },
        { text: "Stato", value: "stato", searchable: true, sortable: true },
        { text: "Totale", value: "totale", searchable: true, sortable: true },
        { text: "Visualizzate", value: "visualizzate", searchable: true, sortable: true },
        { text: "Lette", value: "lette", searchable: true, sortable: true },
        { text: "Azioni", value: "azioni" }
      ],
      caricamentoTabellaNotifiche: false,
      nuovaOppureModifica: '',
      dialogNotificaAperta: false,
      // datiNotificaDaModificare: {},

      idNotificaDaEliminare: null,
      dialogEliminaNotificaAperta: false,
      parolaChiave: null,
      eliminazioneNotificaInCorso: false,
      mostraBottoniPreEliminazione: true,
      mostraBottonePostEliminazione: false,
      mostraAvvisoNotificaEliminata: false,
    }
  },
  watch: {
    'datiForm.tipo': function(nomeBackend, oldVal) {
      this.tipi.forEach(tipo => {
        if(tipo.nome_backend == nomeBackend) {
          this.datiAnteprima.tipo = tipo.nome_frontend
          this.datiAnteprima.colore = tipo.colore
        }
      })
    },
    'datiForm.titolo': function(titolo, oldVal) {
      this.datiAnteprima.titolo = titolo;
    },
    'datiForm.testo': function(testo, oldVal) {
      this.datiAnteprima.testo = testo;

      if (testo.length <= 0 && !this.notificaInviata) {
        this.bordoCkeditor = `
        border: 2px solid #ff5252;
        border-radius: 3px;
        `;
      } else if (testo.length > 0) {
        this.bordoCkeditor = 'border: none;'
      }
    },
  },
  created() {
    // this.getTipi();
    this.getNotifichePerBackoffice();
    
  },
  methods: {
    getNotifichePerBackoffice() {
      this.caricamentoTabellaNotifiche = true;
      axios.get('/backoffice/notifiche/get')
        .then(response => {
          this.notifiche = response.data;
          // console.log(this.notifiche);
        })
        .finally(() => {
          this.caricamentoTabellaNotifiche = false;
        })
    },
		modificaNotificaRoute(notifica) {
			this.$router.push({ name: 'nuova_o_modifica_notifica', params: { azione: 'modifica', notifica: notifica } })
		},
		nuovaNotificaRoute() {
			this.$router.push({ name: 'nuova_o_modifica_notifica', params: { azione: 'nuova' } })
		},
    // apriDialogNuovaNotifica() {
    //   this.nuovaOppureModifica = 'nuova';
    //   this.dialogNotificaAperta = true;
    // },
    // apriDialogModificaNotifica(notifica) {
    //   this.nuovaOppureModifica = 'modifica';
    //   this.datiNotificaDaModificare = notifica;
    //   this.dialogNotificaAperta = true;
    // },
    apriDialogEliminaNotifica(idNotifica) {
      this.dialogEliminaNotificaAperta = true;
      this.idNotificaDaEliminare = idNotifica
    },
    eliminaNotifica() {
      if (!this.$refs.eliminaNotificaForm.validate()) {
        return;
      }
      this.mostraBottoniPreEliminazione = false;
      this.eliminazioneNotificaInCorso = true;
      axios.post('notifiche/elimina', {
        id: this.idNotificaDaEliminare
      })
      .then(res => {
        this.mostraBottonePostEliminazione = true;
        this.eliminazioneNotificaInCorso = false;
        this.mostraAvvisoNotificaEliminata = true;
      })
    },
    resetDialogEliminaNotifica() {
      this.dialogEliminaNotificaAperta = false;
      this.mostraAvvisoNotificaEliminata = false;
      this.idNotificaDaEliminare = null;
      this.parolaChiave = null;
      this.mostraBottoniPreEliminazione = true;
      this.mostraBottonePostEliminazione = false;
      this.getNotifichePerBackoffice();
    },
    getColoreStato(stato) {
      if (stato == 'Inviata') return this.scdGreen
      else if (stato == 'Bozza') return this.scdOrange
    }
  },
}
</script>

<style lang="scss" scoped>
  ._backoffice_empatik {
    font-family: 'Montserrat', sans-serif !important;
  }
</style>